import {
  GET_EARNINGS,
  INITIATE_PAYOUT,
  INITIATE_BATCH_PAYOUT,
  FETCH_PAYOUT_STATUS,
  DOWNLOAD_CROWDSOURCE_EARNINGS,
  FETCH_CROWD_SOURCE_TRANSACTION_HISTORY,
  FETCH_CROWD_SOURCE_TRANSACTION_DETAILS,
  VERIFY_OTP,
  SEND_OTP_URL,
  VERIFY_FR,
  FETCH_USER_TYPES,
  MIGRATE_USER,
  FETCH_WITHDRAWAL_REQUESTS,
  GET_TRANSFER_MODES,
  FETCH_CURATION_LIST,
  FETCH_BANKING_DETAILS_LIST,
  DOWNLOAD_BANK_DETAILS_LIST,
  FETCH_EMPLOYEE_JOB_IDS,
  FETCH_PAYMENT_ACCESS,
  DOWNLOAD_PAYMENTS_REQUESTS_LIST,
  DOWNLOAD_PAYMENT_HISTORY_REQUESTS_LIST,
  ANCHOR_JOBS_LIST,
  DOWNLOAD_PENDING_PAYMENTS_LIST,
  FETCH_COMPETENCY_ASSESSMENT_LIST,
  FETCH_UN_PAID_PAYMENT_LIST,
  FETCH_PENDING_TDS_PAYEMENT_LIST,
  RETRY_INITIATE_PAYOUT,
  FETCH_MULTIPLE_PAYOUT_STATUS,
  DOWNLOAD_PAYMENTS_LIST_BY_JOB_ID_REQUEST
} from "./apiLists";
import httpRequest from "./httpRequest";
import { Buffer } from "buffer";
import toast from "react-hot-toast";

// function getFormData(formData: FormData) {
//   const data = {};
//   for (const [key, value] of formData.entries()) {
//     data[key] = value;
//   }
//   return data;
// }

function base64ToBlob(base64: string, contentType: string): Blob {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}

const dataURLtoBlob = (dataURL: string) => {
  const parts = dataURL.split(";base64,");
  const contentType = "image/jpg";
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
};

class CrowdSourceService {
  fetchEarnings = async (formData: FormData) => {
    const url = `${httpRequest.crowdsourceurl}${GET_EARNINGS}`;
    const data = await httpRequest.post(url, formData);

    if (data.status === 200) {
      return {
        data: data.data,
      };
    }
    return {};
  };

  fetchBankingDetailsList = async (formData: FormData) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_BANKING_DETAILS_LIST}`;
      const data = await httpRequest.post(url, formData);

      if (data.status === 200) {
        return {
          data: data.data,
        };
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };

  fetchEmployeeJobListIDS = async (employee_id: string) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_EMPLOYEE_JOB_IDS}?employee_id=${employee_id}`;
      const data = await httpRequest.get(url);

      if (data.status === 200) {
        return {
          data: data.data,
        };
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };

  getPaymentAccess = async () => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_PAYMENT_ACCESS}`;
      const data = await httpRequest.post(url, {});

      if (data.status === 200) {
        return {
          data: data.data,
        };
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };

  getAnchorJobList = async (employee_id: string) => {
    try {
      const formData = new FormData();
      formData.append("employee_id", employee_id);
      const url = `${httpRequest.broadcastUrl}${ANCHOR_JOBS_LIST}`;
      const data = await httpRequest.post(url, formData);

      console.log(data, "getAnchorJobList");
      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };

  downloadBankDetailsList = async () => {
    try {
      const url = `${httpRequest.crowdsourceurl}${DOWNLOAD_BANK_DETAILS_LIST}`;
      const res: any = await httpRequest.get(url, {
        responseType: "arraybuffer",
      });

      if (res.data) {
        const base64String = Buffer.from(res.data, "binary").toString("base64");
        const blob = base64ToBlob(
          base64String,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `bank_details_list.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success("Downloaded successfully");
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };

  downloadPaymentList = async (
    entity_id: string,
    start_date: string,
    end_date: string
  ) => {
    try {
      const formData = new FormData();
      formData.append("entity_id", entity_id);
      formData.append("start_date", start_date);
      formData.append("end_date", end_date);

      const url = `${httpRequest.crowdsourceurl}${DOWNLOAD_PAYMENTS_REQUESTS_LIST}`;
      const res: any = await httpRequest.post(url, formData, {
        responseType: "arraybuffer",
      });

      if (res.data) {
        const base64String = Buffer.from(res.data, "binary").toString("base64");
        const blob = base64ToBlob(
          base64String,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `payments_list.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success("Downloaded successfully");
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };


   downloadPaymentListByJobId = async (
    entity_id: string,
    start_date: string,
    end_date: string
  ) => {
    try {
      const formData = new FormData();
      formData.append("entity_id", entity_id);
      formData.append("start_date", start_date);
      formData.append("end_date", end_date);

      const url = `${httpRequest.crowdsourceurl}${DOWNLOAD_PAYMENTS_LIST_BY_JOB_ID_REQUEST}`;
      const res: any = await httpRequest.post(url, formData, {
        responseType: "arraybuffer",
      });

      if (res.data) {
        const base64String = Buffer.from(res.data, "binary").toString("base64");
        const blob = base64ToBlob(
          base64String,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `overall_payments_with_job_wise_stats.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success("Downloaded successfully");
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };

  downloadPendingPaymentsList = async (entity_id: string) => {
    try {
      const formData = new FormData();
      formData.append("entity_id", entity_id);

      const url = `${httpRequest.crowdsourceurl}${DOWNLOAD_PENDING_PAYMENTS_LIST}`;
      const res: any = await httpRequest.post(url, formData, {
        responseType: "arraybuffer",
      });

      if (res.data) {
        const base64String = Buffer.from(res.data, "binary").toString("base64");
        const blob = base64ToBlob(
          base64String,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `withdrawals_list.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success("Downloaded successfully");
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };

  downloadPaymentHistoryList = async (
    employee_id: string,
    start_date: string,
    end_date: string
  ) => {
    try {
      const formData = new FormData();
      formData.append("employee_id", employee_id);
      formData.append("start_date", start_date);
      formData.append("end_date", end_date);

      const url = `${httpRequest.crowdsourceurl}${DOWNLOAD_PAYMENT_HISTORY_REQUESTS_LIST}`;
      const res: any = await httpRequest.post(url, formData, {
        responseType: "arraybuffer",
      });

      if (res.data) {
        const base64String = Buffer.from(res.data, "binary").toString("base64");
        const blob = base64ToBlob(
          base64String,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `transaction_history_list.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success("Downloaded successfully");
      }
      return { error: "Error" };
    } catch (error) {
      return { error: "Error" };
    }
  };

  fetchWithdrawalsRequests = async (formData: FormData) => {
    const url = `${httpRequest.crowdsourceurl}${FETCH_WITHDRAWAL_REQUESTS}`;
    const data = await httpRequest.post(url, formData);

    if (data.status === 200) {
      console.log(data, "this is the withdrawls ");
      return { data: data.data };
    }
    return {};
  };

  fetchTransactionHistory = async (formData: FormData) => {
    const url = `${httpRequest.crowdsourceurl}${FETCH_CROWD_SOURCE_TRANSACTION_HISTORY}`;
    const data = await httpRequest.post(url, formData);

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  retryInitiatingPayments = async (form: any) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${RETRY_INITIATE_PAYOUT}`;

      const data = await httpRequest.post(url, form, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Retry payout initiation failed" };
    } catch (e: any) {
      const errMsg =
        e?.response?.data?.message || e?.response?.data?.error || "Error";
      return { error: errMsg };
    }
  };

  initialPayout = async (
    form: any,
    entity_id: string,
    start_date: string,
    end_date: string,
    remarks: string,
    transfterMode: string,
    isWithdrawalRequest?: boolean
  ) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${INITIATE_PAYOUT}`;
      const formData = new FormData();
      // formData.append("transfer_id", form?.transfer_id || "");
      formData.append("employee_id", form?.employee_id);
      formData.append("entity_id", entity_id);
      formData.append(
        "transfer_amount",
        isWithdrawalRequest ? form?.amount : form?.amount_to_be_paid
      );
      formData.append("transfer_currency", form?.transfer_currency || "INR");
      formData.append("transfer_mode", transfterMode || "banktransfer");

      formData.append(
        "withdrawal_request_id",
        isWithdrawalRequest ? form?.id : ""
      );

      if (!isWithdrawalRequest) {
        formData.append("tds_amount", form?.tds_amount?.toString());
        formData.append(
          "total_transactions",
          form?.curated_points?.toString() || ""
        );
      }

      formData.append("remarks", remarks || "");
      formData.append("start_date", start_date || "");
      formData.append("end_date", end_date || "");

      const data = await httpRequest.post(url, formData);

      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Payout initiation failed" };
    } catch (e: any) {
      const errMsg =
        e?.response?.data?.message || e?.response?.data?.error || "Error";
      return { error: errMsg };
    }
  };

  initiateMultiplePayouts = async (
    payoutsList: any[],
    entity_id: string,
    remarks: string = "",
    start_date: string,
    end_date: string,
    transfterMode: string,
    isWithdrawalRequest?: boolean,
    batchPaymentType?: string,
    deSelectedUsersList?: string[]
  ) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${INITIATE_BATCH_PAYOUT}`;

      const formData = JSON.stringify({
        batch_transfer_details: payoutsList?.map((each: any) => {
          return {
            // transfer_id: each.transfer_id || "",
            transfer_amount: isWithdrawalRequest
              ? each?.amount
              : each?.amount_to_be_paid,
            transfer_currency: each?.transfer_currency || "INR",
            transfer_mode: transfterMode || "banktransfer",
            // beneficiary_id: "d1b2cc8a_960c_4578_9bc3_fcbedd883518",
            employee_id: each?.employee_id,
            entity_id: entity_id,
            remarks: remarks || "",
            start_date,
            end_date,
            withdrawal_request_id: isWithdrawalRequest ? each?.id : "",
          };
        }),
        batch_payment_type: batchPaymentType || "",
        start_date,
        end_date,
        entity_id,
        transfer_mode: transfterMode || "banktransfer",
        deselected_employee_ids: deSelectedUsersList || [],
      });

      const data = await httpRequest.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
      });

      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Multiple payouts initiation failed" };
    } catch (e: any) {
      const errMsg =
        e?.response?.data?.message || e?.response?.data?.error || "Error";
      return { error: errMsg };
    }
  };

  fetchCurationList = async (
    employee_id: string,
    start_date: string,
    end_date: string
  ) => {
    try {
      const formData = new FormData();
      formData.append("employee_id", employee_id);
      formData.append("start_date", start_date || "");
      formData.append("end_date", end_date || "");

      const url = `${httpRequest.crowdsourceurl}${FETCH_CURATION_LIST}`;

      const data = await httpRequest.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
      });

      if (data.status === 200) {
        return {
          data: data.data,
        };
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };

  fetchCompentencyAssessmentList = async (employee_id: string) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_COMPETENCY_ASSESSMENT_LIST}?employee_id=${employee_id}`;
      const data = await httpRequest.get(url);
      if (data.status === 200) {
        return {
          data: data.data,
        };
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };

  fetchTransferModes = async (entity_id: string) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${GET_TRANSFER_MODES}?entity_id=${entity_id}`;

      const data = await httpRequest.get(url);

      if (data.status === 200) {
        return { data: data.data };
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };


   fetch_multiple_payout_status = async (
    entity_id: string,
    start_date: string,
    end_date: string,
  ) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_MULTIPLE_PAYOUT_STATUS}`;
      const formData = new FormData();
      formData.append("start_date", start_date);
      formData.append("entity_id", entity_id);
      formData.append("end_date", end_date);

      const data = await httpRequest.post(url, formData);

      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Error" };
    } catch (e: any) {
      const errMsg =
        e?.response?.data?.message || e?.response?.data?.error || "Error";
      return { error: errMsg };
    }
  };

  fetch_payout_status = async (
    employee_id: string,
    entity_id: string,
    transfer_id: string
  ) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_PAYOUT_STATUS}`;
      const formData = new FormData();
      formData.append("employee_id", employee_id);
      formData.append("entity_id", entity_id);
      formData.append("transfer_id", transfer_id);

      const data = await httpRequest.post(url, formData);

      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Error" };
    } catch (e: any) {
      const errMsg =
        e?.response?.data?.message || e?.response?.data?.error || "Error";
      return { error: errMsg };
    }
  };

  fetch_un_paid_payment_list = async (entity_id: string) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_UN_PAID_PAYMENT_LIST}`;
      const formData = new FormData();
      formData.append("entity_id", entity_id);

      const data = await httpRequest.post(url, formData);

      if (data.status === 200) {
        return {
          data: data.data,
        };
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };

  fetch_pending_tds_list = async (entity_id: string) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_PENDING_TDS_PAYEMENT_LIST}`;
      const formData = new FormData();
      formData.append("entity_id", entity_id);

      const data = await httpRequest.post(url, formData);

      if (data.status === 200) {
        return {
          data: data.data,
        };
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };

  download_earnings = async (
    employee_id: string,
    entity_id: string,
    start_date: string,
    end_date: string
    // transfer_id: string,
  ) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${DOWNLOAD_CROWDSOURCE_EARNINGS}`;
      const formData = new FormData();
      formData.append("employee_id", employee_id);
      formData.append("entity_id", entity_id);
      formData.append("start_date", start_date);
      formData.append("end_date", end_date);
      // formData.append("transfer_id", transfer_id);

      const data = await httpRequest.post(url, formData);

      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };

  fetch_transaction_details = async (
    employee_id: string,
    entity_id: string,
    transfer_id: string
  ) => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_CROWD_SOURCE_TRANSACTION_DETAILS}`;
      const formData = new FormData();
      formData.append("employee_id", employee_id);
      formData.append("entity_id", entity_id);
      formData.append("transfer_id", transfer_id);

      const data = await httpRequest.post(url, formData);

      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };

  verify_otp = async (
    otp: string,
    phonenumber: string,
    userID: string | undefined,
    verifyToken: string,
    type?: string
  ) => {
    try {
      let formdata = new FormData();
      formdata.append("phone_number", phonenumber);
      formdata.append("app_id", "aso");
      if (userID) {
        formdata.append("user_id", userID);
      }
      formdata.append("otp", otp);
      // formdata.append("type", type || "");
      const url = `${httpRequest.signupurl}${VERIFY_OTP}`;

      // const verifyotpresponse = await httpRequest.post(url, formdata);

      const verifyotpresponse = await httpRequest.post(url, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + verifyToken,
        },
      });

      if (verifyotpresponse.status === 200) {
        return {
          ...verifyotpresponse.data,
        };
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };

  sendotp = async (phonenumber: string, entity_id: string) => {
    try {
      let formdata = new FormData();
      formdata.append("phone_number", phonenumber);
      formdata.append("app_id", "aso");
      formdata.append("entity_id", entity_id);
      const url = `${httpRequest.signupurl}${SEND_OTP_URL}`;
      const data = await httpRequest.post(url, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (data.status === 200) {
        return {
          ...data,
        };
      }
      return { error: "errror" };
    } catch (e) {
      return { error: "errror" };
    }
  };

  verify_fr = async (
    image: string,
    image2: string,
    user_id: string,
    authtoken: string
  ) => {
    try {
      let formdata = new FormData();
      formdata.append("user_id", user_id);

      formdata.append("app_id", "aso");
      formdata.append("fr_required", "1");

      const imgBob1 = dataURLtoBlob(image);
      formdata.append("image", imgBob1);

      const img1Bob2 = dataURLtoBlob(image2);
      formdata.append("image2", img1Bob2);

      const frurl = `${httpRequest.signupurl}${VERIFY_FR}`;
      const data = await httpRequest.post(frurl, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + authtoken,
        },
      });

      if (data.status === 200) {
        return { ...data?.data };
      }
      return { error: "Failed to verify face recognition" };
    } catch (e: any) {
      const errMsg =
        e?.response?.data?.message || e?.response?.data?.error || "Error";
      return { error: errMsg };
    }
  };

  fetch_user_types = async () => {
    try {
      const url = `${httpRequest.crowdsourceurl}${FETCH_USER_TYPES}`;
      const data = await httpRequest.get(url);

      if (data.status === 200) {
        console.log(data.data, "use types");
        return data.data;
      }
      return { error: "Error" };
    } catch (e) {
      return { error: "Error" };
    }
  };

  migrateUser = async (
    previous_email_id: string,
    new_email_id: string,
    from_user_type_id: string,
    to_user_type_id: string,
    employee_code: string
  ) => {
    try {
      let formdata = new FormData();
      formdata.append("previous_email_id", previous_email_id);
      formdata.append("new_email_id", new_email_id);
      formdata.append("from_user_type_id", from_user_type_id);
      formdata.append("to_user_type_id", to_user_type_id);
      formdata.append("employee_code", employee_code);
      formdata.append("app_id", "aso");

      const url = `${httpRequest.crowdsourceurl}${MIGRATE_USER}`;
      const data = await httpRequest.post(url, formdata);

      if (data.status === 200) {
        return {
          ...data,
        };
      }
      return { error: "errror" };
    } catch (e) {
      return { error: "errror" };
    }
  };
}

const crowdSourceService = new CrowdSourceService();

export default crowdSourceService;
